import React, { useState } from "react";
import { FaChevronRight } from "react-icons/fa";
import AppPagination from "../AppPagination";
import AppModal from "./AppModal";

const MissedFollowupModal = ({ showMissedModal, setShowMissedModal }) => {
  const data = [
    {
      id: 1,
      name: "Test2",
      date: "02-03-2026 12:19",
      assign: "kajol demo",
      mobile: "919887878790",
      followup: "05-03-2026 12:00",
      status: "Processing",
    },
    {
      id: 2,
      name: "Trueline Solution",
      date: "05-03-2026 13:50",
      assign: "kajol demo",
      mobile: "919913299865",
      followup: "06-03-2026 13:00",
      status: "Processing",
    },
    {
      id: 3,
      name: "ABC",
      date: "06-03-2026 11:59",
      assign: "kajol demo",
      mobile: "917976766556",
      followup: "09-03-2026 12:00",
      status: "Processing",
    },
    {
      id: 4,
      name: "PQR",
      date: "06-03-2026 14:34",
      assign: "kajol demo",
      mobile: "919876567889",
      followup: "09-03-2026 14:00",
      status: "Processing",
    },
    {
      id: 5,
      name: "Shubham sir",
      date: "06-04-2026 12:16",
      assign: "kajol demo",
      mobile: "919758063694",
      followup: "07-04-2026 12:00",
      status: "Processing",
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 3;

  const indexOfLastItem = currentPage * itemsPerPage;

  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const changePage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <AppModal
      show={showMissedModal}
      setShow={setShowMissedModal}
      title="Lead Missed Followup"
      size="modal-xl"
    >
      <div className="table-responsive">
        <table className="table align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th>No.</th>
              <th>Customer Name</th>
              <th>Date</th>
              <th>Assign To</th>
              <th>Mobile</th>
              <th>Follow Up Date</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {currentItems.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>

                <td className="text-primary fw-semibold">{item.name}</td>

                <td>{item.date}</td>

                <td>{item.assign}</td>

                <td>{item.mobile}</td>

                <td>{item.followup}</td>

                <td>{item.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <AppPagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={currentItems.length}
        itemsPerPage={itemsPerPage}
        onPageChange={changePage}
      />
    </AppModal>
  );
};

export default MissedFollowupModal;
